<template>
   <div class="wrapper">
      <div class="d-flex align-items-center justify-content-between">
         <h1 class="mb-2 title">
            <slot>{{ title }}</slot>
         </h1>
      </div>
      <hr class="my-0" />
   </div>
</template>

<script>
export default {
   props: {
      title: {
         type: String,
      },
   },
};
</script>

<style lang="scss" scoped>
.wrapper {
   margin-bottom: 2rem;
}

.title {
   color: black;
   font-size: 32px;
   font-weight: 700 !important;
}
</style>
